import { watchEffect } from 'vue'

/**
 * Custom scroll strategy that locks the menu position to prevent repositioning during scroll
 * @param {ScrollStrategyData} data - The scroll strategy data from Vuetify
 * @param {StrategyProps} props - The strategy props
 * @param {EffectScope} scope - The effect scope for cleanup
 */
export const lockPositionScrollStrategy = (data, props, scope) => {
  let initialPosition = null
  let positionLocked = false

  const lockPosition = () => {
    if (!data.contentEl.value || positionLocked) return

    // Wait for next frame to ensure element is properly positioned
    requestAnimationFrame(() => {
      if (!data.contentEl.value) return

      const rect = data.contentEl.value.getBoundingClientRect()
      initialPosition = {
        top: rect.top,
        left: rect.left
      }

      // Apply fixed positioning
      const element = data.contentEl.value
      element.style.position = 'fixed !important'
      element.style.top = `${initialPosition.top}px !important`
      element.style.left = `${initialPosition.left}px !important`
      element.style.transform = 'none !important'
      element.style.willChange = 'auto'

      positionLocked = true
    })
  }

  // Watch for when the content element becomes available
  scope.run(() => {
    watchEffect(() => {
      if (data.contentEl.value && data.isActive.value && !positionLocked) {
        lockPosition()
      }
    })
  })

  // Override updateLocation to prevent repositioning
  if (data.updateLocation) {
    const originalUpdateLocation = data.updateLocation.value
    data.updateLocation.value = (e) => {
      // If position is locked, don't allow updates
      if (positionLocked && initialPosition && data.contentEl.value) {
        const element = data.contentEl.value
        element.style.position = 'fixed !important'
        element.style.top = `${initialPosition.top}px !important`
        element.style.left = `${initialPosition.left}px !important`
        element.style.transform = 'none !important'
        return
      }

      // If not locked yet, allow initial positioning then lock
      if (originalUpdateLocation) {
        originalUpdateLocation(e)
        if (!positionLocked) {
          setTimeout(lockPosition, 0)
        }
      }
    }
  }
}
